<template>
    <div class="survey-note-form-coaching-summary">

        <b-form-radio-group buttons
                            :stacked="$mq == 'sm'"
                            v-model="selectedAreaIndex"
                            :options="tabOptions">
        </b-form-radio-group>

        <div v-if="currentArea == 'HABITS'">
            <patient-coaching-summary-habits :show-edit-links="showEditLinks">
            </patient-coaching-summary-habits>
        </div>
        <div v-if="currentArea == 'LOGS'">
            <patient-coaching-summary-logs>
            </patient-coaching-summary-logs>
        </div>
        <div v-if="currentArea == 'MINDSET'">
            <patient-coaching-summary-mindset>
            </patient-coaching-summary-mindset>
        </div>
        <div v-if="currentArea == 'GOALS'">
            <patient-coaching-summary-goals :show-edit-links="showEditLinks">
            </patient-coaching-summary-goals>
        </div>
        <div v-if="currentArea == 'PATH'">
            <patient-coaching-summary-path :show-edit-links="showEditLinks">
            </patient-coaching-summary-path>
        </div>

    </div>
</template>

<script>
import * as _ from 'lodash'

export default {
    name: 'SurveyNoteFormCoachingSummary',
    props: {
        areas: Array
    },
    data() {
        return {
            selectedAreaIndex: 0
        }
    },
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        tabOptions() {
            return _.map(this.areas, (area, i) => {
                return {value: i, text: this.$i18n.gt(`LABEL_COACHING_AREA_${area}`)}
            })
        },
        currentArea() {
            return this.areas[this.selectedAreaIndex]
        },
        showEditLinks() {
            return this.$auth.canEditWellnessPlan()
        }
    }
}
</script>

<style lang="scss">
.survey-note-form-coaching-summary {
    // see styles in SurveyNoteForm - SurveyNoteFormTrendCharts uses the same styles
}
</style>
